import React, { Component } from "react";

import {Button ,ButtonGroup,Glyphicon,Form, FormGroup, ControlLabel ,FormControl,ToggleButtonGroup ,ToggleButton,Well} from "react-bootstrap";
import "./Logic.css"

import ConditionCreate from "./ConditionCreate.js"
import ReactDragList from 'react-drag-list'
/*


      Create Logical conditions from input data


      I would like this interface to cope with the more complex arrangment of logic

      //Possible in-puts are
      //InputXvalue
      //outputXstate
      //on True do this
      //on False do this


      Enable/Diable logic
      Description auto generation



      Logic can be nested in the heating sheduler that was used for clowne
      two types of logic were manually created
      one was if any of the output zones were turned on, automaticly turn on the pump
      the other was for cotrolling if the heating was on or off

      ```JSON
      {
            "or":[{"opperator":"==","data":{"v1":{"var":"temperature_1_enabled"},"v2":{"value":2}}},
                {"and":[
                    {"opperator":"==","data":{"v1":{"var":"temperature_1_enabled"},"v2":{"value":1}}},
                    {"or":[
                        {"opperator":"<=","data":{"v1":{"var":"temperature_1"},"v2":{"var":"Heating_Schedule_1"}}},
                        {"and":[
                            {"opperator":"==","data":{"v1":{"var":"temperature_1_boost"},"v2":{"value":1}}},
                            {"opperator":"<=","data":{"v1":{"var":"temperature_1"},"v2":{"var":"temperature_1_boost_temp"}}}
                        ]}]
                    }
            ]}]}
      ```

*/

const testLogic={"or":
          [{"opperator":"==","data":{"v1":{"var":"temperature_1_enabled"},"v2":{"value":2}}},
           {"and":[
                    {"opperator":"==","data":{"v1":{"var":"temperature_1_enabled"},"v2":{"value":1}}},
                    {"or":[
                        {"opperator":"<=","data":{"v1":{"var":"temperature_1"},"v2":{"var":"Heating_Schedule_1"}}},
                        {"and":[
                            {"opperator":"==","data":{"v1":{"var":"temperature_1_boost"},"v2":{"value":1}}},
                            {"opperator":"<=","data":{"v1":{"var":"temperature_1"},"v2":{"var":"temperature_1_boost_temp"}}}
                        ]}]
                    }
            ]}]}


function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}


function calcLevel(data){
  console.log("====== Calc logic level =====")
  let tempdata=[]
  var logicJoin=0
  var logicIndex=-1
  //Need to balance and and ors where possible, might be to hard in some cases
  for(let item in data){
    console.log(data[item])
    if(data[item].data=="or" || data[item].data=="and"){
      logicJoin+=1;
      logicIndex=item;
    }
  }

  if(logicJoin==0){
    for (let item in data){
      data[item].level=0
      tempdata.push(data[item])
    }
  }
  else if(logicJoin==1){
    //Only 1 logical opperator
    console.log(logicIndex)
    tempdata=data.splice(logicIndex,1)
    tempdata[0].level=0
    let level=1;
    for (let item in data){
      data[item].level=level
      tempdata.push(data[item])
    }
  }
  else{
    //Make the level follow previous value expand out each time? do i need a method for detailed control of this, step in/out?
    let level=0
    for (let item in data){
      data[item].level=level
      if(data[item].data=="or" || data[item].data=="and"){
        level=level+1
      }
      tempdata.push(data[item])
    }
    tempdata=data
  }
  console.log(tempdata)
  return tempdata

}


function formatLogic(data){
  //the bit thats most likly to fuck up.

    //Perform the reverse function for generating a tree from flat logic
    var dataOut=[]
    for(let i=data.length-1;i>=0;i--){
      if(typeof(data[i].data)=="string"){
        if(i==0){
          dataOut={[data[i].data]:dataOut}
        }else{
          dataOut=[{[data[i].data]:dataOut}]
        }
      }
      else
        dataOut.push(data[i].data)
    }
    //step through the levels
    return dataOut

}




function flattenLogic(data){
  var level=0
  var index=0
  var stack=[]
  var flattened=[]
  stack.push(data)
  while(stack.length!=0){
    let d=stack.pop()
    for (var item in d){
        if(typeof(item)=="string" && isNaN(item)){
            flattened.push({level:level,data:item,index:guid()})
            stack.push(d[item])
            level=level+1
            index=index+1
        }
        else{
            if("opperator" in d[item]){

               flattened.push({level:level,data:d[item],index:guid()})
              index=index+1
            }
            else{
                stack.push(d[item])
            }
        }
    }
  }
  console.log("Flattened result")
  console.log(flattened)
  return flattened
}





function MacroSelect(props){

  let macrolist={"enum":[],"enumNames":[]}


  //I want to sort this list by name

  let tempsort=[]


  for (var key in props.macros){
      tempsort.push([props.macros[key].name,key])
    //  macrolist.enum.push(key)
  //    macrolist.enumNames.push(props.macros[key].name)
  }

  tempsort.sort()
  for (var key in tempsort){
    macrolist.enum.push(tempsort[key][1])
    macrolist.enumNames.push(tempsort[key][0])
  }

  return (<select key={"LogicCreateMacroChoice-"+props.id} value={props.current} onChange={(e)=>props.callback(e,props.id)}>
    <option value="">None</option>
      {macrolist.enum.map((d,i) =><option value={d} key={d}>{macrolist.enumNames[i]}</option>)}
    </select>)
}






export default class LogicCreate extends Component {
    constructor(props) {
      super(props);
      this.state = {
        data:props.data,
        testLogic:flattenLogic(props.data.logic),
        vars:props.vars,
        showEdit:false,
        editIndex:0,
        newAction:false,
        addNew:false,
        nameEdit:false,
        redraw:true,
        macroList:{"enum": [], "enumNames": []},
        varlist:{"enum": [], "enumNames": []},
        outList:{"enum": [], "enumNames": []},
        conditionEdit:false,
        drag:false
      };
      this.blankCondition={



      }
    }

    componentDidUpdate(prevProps){


    }


    flatten(logic){
      console.log(logic)
      for(var item in logic){
        console.log(item)
      }
    }


    componentWillMount(){

      console.log("Logic Data")
      console.log(this.props.data)

  //    let macrolist=this.state.macroList
      //console.log(this.props.macros)
    //  for (var key in this.props.macros){
    //    macrolist.enum.push(key)
//        macrolist.enumNames.push(this.props.macros[key].name)
  //    }

  //    this.setState({macroList:macrolist})

    //  let logic=this.flatten(this.state.data.logic)
      //this.setState({testLogic:logic})


    }


    editName=()=>{
    this.setState({nameEdit:true})
    }
    nameChange=(event)=>{
      console.log(event)
      let temp=this.state.data
      temp.name=event.target.value
      this.setState({data: temp});
    }

    saveName=()=>{
      this.setState({nameEdit:false})
    }

    setLevel(level){

    let temp=this.state.data
    temp["level"]=level
    this.setState({data: temp});

  }
  logicDuration=(event)=>{
    let temp=this.state.data
    temp["active_duration"]=parseInt(event.target.value)
    this.setState({data: temp});
  }

  logicTimeout =(event) =>{
    let temp=this.state.data
    temp["timeout"]=parseInt(event.target.value)
    this.setState({data: temp});
  }



clearFalse=()=>{
  console.log("Macro False Clear")
  let temp=this.state.data
  temp["MacroFalse"]=""
  this.setState({data: temp});



}
clearTrue=()=>{
  console.log("Macro True Clear")
  let temp=this.state.data
  temp["MacroTrue"]=""
  this.setState({data: temp});



}

select=(macroAssignment)=>{
    console.log(" show Action select and assign it to the macros "+macroAssignment+" action")


}

macroSelect=(event,id)=>{

  console.log("Macro Select callback")
  console.log(event.target.value)
  let macroid=event.target.value
  let temp=this.state.data
  temp[id]=macroid
  console.log(temp)
  console.log(id)
  this.setState({data: temp});


}



newCondition=()=>{
  this.setState({drag:true})
  this.setState({conditionEdit:true})
}


handleDragUpdate= (evt, updated) => {
  console.log("Drag end")
  console.log(evt)
  console.log(updated)
  let tempOrder=updated
  this.setState({testLogic:tempOrder})
  tempOrder=calcLevel(updated)
  this.setState({testLogic:tempOrder})
  //level needs to match new dropped location.
}

conditionCallback=(cmd,data)=>{
  console.log(data)
  if(cmd=="cancel"){
    this.setState({conditionEdit:false})
  }
  if(cmd=="append" || cmd=="appendedit"){
    console.log("Add new condition")
    this.setState({conditionEdit:false})
    let temp=this.state.testLogic
    let uid=guid()
    this.setState({lastadded:""})
    temp.push({level:0,index:uid,edit:true,data:data})
    temp=calcLevel(temp)
    this.setState({testLogic:temp})
    if(cmd=="appendedit"){
      this.setState({lastadded:uid})
    }
    //create the new condtion and show it in edit mode
  }
  if(cmd=="delete"){
    console.log("delete index"+data)
    let temp=this.state.testLogic
    console.log(temp)
    this.setState({lastadded:""})
    temp.splice(data,1)
    temp=calcLevel(temp)
    //create the new condtion and show it in edit mode
    //temp.remove(data)
    console.log(temp)
    this.setState({testLogic:temp})
  }

}


checkSaveData=()=>{

  //Data needs to be formatted into usual logic format. and verified?
  console.log("Dummy save logic id="+this.props.logicid)
  console.log(this.state.data)
  console.log("Raw data needs formatting")
  let logic=formatLogic(this.state.testLogic)
  let temp=this.state.data
  temp.logic=logic
  this.setState({data:temp})
  this.props.callback({},"save")

}

dragToggle=()=>{
  this.setState({drag:!this.state.drag})
}
    render(){
      return (<div>
        <Well>  {this.state.nameEdit ? (
            <div>
            <input value={this.state.data.name} onChange={this.nameChange}></input>
            <Button onClick={()=>this.saveName()}>Done</Button>
            <br/>
            </div>
          ):(
            <div>
          <h4 title="title" ><span className={"alert"+this.state.data.level}>{this.state.data.name}</span>&nbsp;<Glyphicon onClick={()=>this.editName()} title="Edit name" className="iconBut" glyph="pencil" />
            <ButtonGroup className="ib pull-right">
                <Button className="BGred" onClick={()=>this.setLevel(3)}>Red</Button>
                <Button className="BGamber" onClick={()=>this.setLevel(2)}>Amber</Button>
                <Button className="BGgreen" onClick={()=>this.setLevel(1)}>Green</Button>
                <Button onClick={()=>this.setLevel(0)}>None</Button>
            </ButtonGroup>
            </h4>
          </div>)
          }</Well>
        <hr/>
        <Well>

            <h3 className="flexFill">
                  <div>Logic Conditions &nbsp;
                      <Button onClick={()=>this.newCondition()}>+ Add Condition</Button>
                  </div>
                  <div>
                      {this.state.drag ?   <Button onClick={()=>this.dragToggle()}>Drag</Button>:<Button onClick={()=>this.dragToggle()}>Edit</Button>}

                  </div>
            </h3>
          {/*  {this.state.testLogic.map((d,i)=><ConditionCreate data={d}></ConditionCreate>)}*/}

            {this.state.conditionEdit==true ? (<ConditionCreate callback={this.conditionCallback} data={this.blankCondition} edit={true} new={true} inputs={this.props.inputs} outputs={this.props.outputs} vars={this.props.vars}>New Condition</ConditionCreate>):


            (<span>{this.state.drag==false ? (
              <ReactDragList
                     dataSource={this.state.testLogic}
                     row={(d, i) => (
                      <div key={"T"+d.index} ><ConditionCreate data={d} drag={this.state.drag} inputs={this.props.inputs} lastedit={this.state.lastadded} uid={d.index} index={i} outputs={this.props.outputs} vars={this.props.vars} callback={this.conditionCallback}></ConditionCreate></div>
                    )}
                     key={"T"+this.state.testLogic.length}
                     rowKey="index"
                     handles={false}
                     disabled={false}
                     dragClass="drag-item"
                     ghostClass="dragged-item"
                     animation="100"
                    className="simple-drag"
                    rowClassName="simple-drag-row"
                     onUpdate={this.handleDragUpdate}
                   />):(<ReactDragList
                          dataSource={this.state.testLogic}
                          row={(d, i) => (
                           <div key={"D"+d.index} ><ConditionCreate data={d} drag={this.state.drag} inputs={this.props.inputs} lastedit={this.state.lastadded} uid={d.index} index={i} outputs={this.props.outputs} vars={this.props.vars}  callback={this.conditionCallback}></ConditionCreate></div>
                         )}
                          key={"F"+this.state.testLogic.length}
                          rowKey="index"
                          handles={false}
                          disabled={true}
                          dragClass="drag-item"
                          ghostClass="dragged-item"
                          animation="100"
                         className="simple-drag"
                         rowClassName="simple-drag-row"
                          onUpdate={this.handleDragUpdate}
                        />)}



                   </span>)}



        </Well>


        <Well>
          <Form inline >
              <FormGroup>
              <span className="formTextPad"><b>Timeout:</b></span>
              <FormControl type="number" id="logicTimeout" value={this.state.data.timeout} onChange={this.logicTimeout} placeholder="Time in seconds" width="4" />
              <span className="formTextPad"><b>Duration:</b></span>
              <FormControl type="number" id="logicDelay" value={this.state.data.active_duration} onChange={this.logicDuration} placeholder="Time in seconds" width="4" />
              </FormGroup>{' '}

          </Form>
                <p><b>Timeout</b>: When the logic is triggered how long until it can go off again</p>
                <p><b>Duration</b>: The logic has to be true for this period of time before its triggered. Useful for temperatures and for inactivity monitoring</p>

        </Well>
        <Well>

        <h3>When True</h3>
        <p>This Action is run when the event becomes true</p>
        <MacroSelect key="MacroTrueSelect" id="MacroTrue" current={this.state.data.MacroTrue}  macros={this.props.macros} callback={this.macroSelect}></MacroSelect>
        <br/>
        {this.state.data.MacroTrue.length!=0? (<span><Button onClick={()=>this.clearTrue()}>Clear Action</Button><Button onClick={()=>this.props.callback({id:this.state.data.MacroTrue},"macroedit")}>Edit Action</Button></span>):("")}
        <Button onClick={()=>this.props.callback({},"macroNewTrue")}>Create New</Button>

        </Well>
        <Well>
        <h3>When False</h3>


        <p>This Action is run when the event becomes false</p>
        <MacroSelect key="MacroFalseSelect" id="MacroFalse" current={this.state.data.MacroFalse}  macros={this.props.macros} callback={this.macroSelect}></MacroSelect>
        <br/>
        {this.state.data.MacroFalse.length!=0? (<span><Button onClick={()=>this.clearFalse()}>Clear Action</Button><Button onClick={()=>this.props.callback({id:this.state.data.MacroFalse},"macroedit")}>Edit Action</Button></span>):("")}
        <Button onClick={()=>this.props.callback({},"macroNewFalse")}>Create New</Button>



        </Well>

        <Well>
          <Button onClick={()=>this.checkSaveData()}>Save</Button>
          <Button onClick={()=>this.props.callback({},"close")}>Cancel</Button>
        </Well>


        </div>





      )





    }

}



// WEBPACK FOOTER //
// ./src/programmerComponents/LogicCreate.js